import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';



const OverviewRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/aovprogressbar/overview" */
    'routes/Extensions/AovProgressBar/OverviewRoute'
  )
));

const ConnectionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/aovprogressbar/connections" */
    'routes/Extensions/AovProgressBar/ConnectionsRoute'
  )
));

const UpdateAovProgressBarRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/aovprogressbar/update" */
    'routes/Extensions/AovProgressBar/UpdateAovProgressBarRoute'
  )
));


const getAovProgressBarRoutes = () => {
  return [
    {path: paths.getPathAovProgressBarOverview(), component: OverviewRoute},
    {path: paths.getPathAovProgressBarConnections(), component: ConnectionsRoute},
    {path: paths.getPathAddAovProgressBar(), component: UpdateAovProgressBarRoute},
    {path: paths.getPathEditAovProgressBar(":apbId"), component: UpdateAovProgressBarRoute},
    {path: paths.getPathReplicateAovProgressBar(":apbId"), render: (props) => <UpdateAovProgressBarRoute {...props} isReplicate={true} />},
  ]
}


export { getAovProgressBarRoutes };
